import React, { useCallback, useEffect, useState } from "react";
import "./Replayer.scss";
import { Button, ButtonGroup, ProgressBar } from "react-bootstrap";
import "react-bootstrap-range-slider/dist/react-bootstrap-range-slider.css";
import {
  SkipBackwardFill,
  SkipBackward,
  SkipForward,
  SkipForwardFill,
  SkipEnd,
  SkipStart,
  PlayFill,
  StopFill,
  ArrowRepeat,
  Fullscreen,
  FullscreenExit,
  Keyboard,
  VolumeUpFill,
  VolumeMuteFill
} from "react-bootstrap-icons";
import { useTranslation } from "react-i18next";
import i18n from "i18next";
import NumberFormat from "react-number-format";
import logo from "../assets/logo.png";
import ReplayHand from "../api/ReplayHand";
import ReplayAction from "../api/ReplayAction";
import {
  AspectRatio,
  assets,
  HandEventType,
  ReplayerMode,
  ReplayerPreferredSeats,
  RoomType
} from "../api/ReplayVariables";
import ReplayZone from "./ReplayZone";
import OptionsDialog from "./OptionsDialog";

import flopMP3 from "../assets/sounds/FLOP.mp3";
import turnMP3 from "../assets/sounds/TURN.mp3";
import riverMP3 from "../assets/sounds/RIVER.mp3";

import flopWAV from "../assets/sounds/FLOP.wav";
import turnWAV from "../assets/sounds/TURN.wav";
import riverWAV from "../assets/sounds/RIVER.wav";

import checkMP3 from "../assets/sounds/CHECK.mp3";
import checkWAV from "../assets/sounds/CHECK.wav";

import callMP3 from "../assets/sounds/CALL.mp3";
import callWAV from "../assets/sounds/CALL.wav";

import betMP3 from "../assets/sounds/BET.mp3";
import betWAV from "../assets/sounds/BET.wav";

import raiseMP3 from "../assets/sounds/RAISE.mp3";
import raiseWAV from "../assets/sounds/RAISE.wav";

import collectMP3 from "../assets/sounds/COLLECT.mp3";
import collectWAV from "../assets/sounds/COLLECT.wav";
import { withRouter } from "react-router-dom";
import Preload from "../webapp/components/Preload";
import Div100vh from "react-div-100vh";
import GATracker from "../webapp/components/GATracker";
import { sendCommand } from "../app/components/Bridge";

import { ungzip } from 'pako';

function Replayer({ size, mode, match, history }) {
  const [hand, setHand] = useState(new ReplayHand());
  const [replayId, setReplayId] = useState(null);
  const [fullScreen, setFullScreen] = useState(false);
  const [action, setAction] = useState(new ReplayAction());
  const [preferredSeat, setPreferredSeat] = useState(2);
  const [mainSeat, setMainSeat] = useState(2);
  const [nbActions, setNbActions] = useState(0);
  const [playing, setPlaying] = useState(
    mode === ReplayerMode.EMBEDDED ||
      mode === ReplayerMode.CODE ||
      mode === ReplayerMode.APP_STANDALONE
      ? false
      : true
  );
  const [currentActionIndex, setCurrentActionIndex] = useState(0);
  const [background, setBackground] = useState(null);
  const [table, setTable] = useState(1);
  const [showOptions, setShowOptions] = useState(false);
  const [showTimeline, setShowTimeline] = useState(true);
  const [showShortcuts, setShowShortcuts] = useState(false);
  const [handIndex, setHandIndex] = useState(1);
  const [total, setTotal] = useState(1);

  const [anonymous, setAnonymous] = useState(false);
  const [showAllCards, setShowAllCards] = useState(false);

  const [preloadCurent, setPreloadCurrent] = useState(0);
  const [preloadTotal, setPreloadTotal] = useState(1);
  const [error, setError] = useState(null);
  const [fetching, setFetching] = useState(true);
  const [loaded, setLoaded] = useState(false);
  const [sessionHands, setSessionHands] = useState(null);

  //let _remember = localStorage.getItem("hud-disclaimer") === "true";
  const [showDisclaimer, setShowDisclaimer] = useState(true);

  const closeDisclaimer = ()=>{
    setShowDisclaimer(false);
    //localStorage.setItem("hud-disclaimer", true);
  }

  window.playHand = (data, _anonymous, _showAllCards, _handIndex, _total) => {
    //console.log("_handIndex", _handIndex);
    setAnonymous(_anonymous);
    setShowAllCards(_showAllCards);
    setHandIndex(_handIndex);
    setTotal(_total);
    setCurrentActionIndex(0);
    setHand(ReplayHand.from(JSON.parse(data)));
    setError(null);
    setFetching(false);
    setTimeout(() => {
      setLoaded(true);
    }, 500);
  };

  window.setAnonymous = (_anonymous) => {
    setAnonymous(_anonymous);
  };

  window.setShowAllCards = (_showAllCards) => {
    setShowAllCards(_showAllCards);
    //console.error("setShowAllCards", _showAllCards);
  };
  const doSetShowOptions = (show) => {
    doSetShowShortcuts(false);
    setShowOptions(show);
    if(window.bridge) window.bridge.setShowOptions(show);
  };
  const doSetShowShortcuts = (show) => {
    setShowShortcuts(show);
    if(window.bridge) window.bridge.setShowShortcuts(show);
  };

  const onBackgroundChange = (_background) => {
    if(window.bridge) window.bridge.setBackground(_background);
    let _hand = new ReplayHand();
    Object.assign(_hand, hand);
    _hand.background = _background;
    setHand(_hand);
    console.log("background", _background);
    //setBackground(_background);
  };

  const onTableChange = (_table) => {
    if(window.bridge) window.bridge.setTable(_table);
    let _hand = new ReplayHand();
    Object.assign(_hand, hand);
    _hand.table = _table;
    setHand(_hand);
  };

  window.setFullscreen = (_fullscreen) => {
    setFullScreen(_fullscreen);
    console.error("setFullscreen", _fullscreen);
  };
  window.stop = () => {
    console.log("stopping");
    setPlaying(false);
  };
  window.showHandSummary = () => {
    console.log("show hand summary");
    doSetCurrentActionIndex(hand.actions.length - 1);
  };

  //---------
  //SPEED
  //---------
  let _speed = localStorage.getItem("speedNum");
  if (isNaN(_speed) || _speed === null) {
    _speed = 1;
    localStorage.setItem("speedNum", _speed);
  } else {
    _speed = parseInt(_speed);
  }
  const [speed, setSpeed] = useState(_speed);
  const speedChanged = () => {
    if (speed < 2) {
      localStorage.setItem("speedNum", speed + 1);
      setSpeed(speed + 1);
    } else {
      localStorage.setItem("speedNum", 1);
      setSpeed(1);
    }
  };

  //---------
  //BB MODE
  //---------
  let _bbMode =
    localStorage.getItem("bbMode") === null ||
    localStorage.getItem("bbMode") === "true";
  const [bbMode, setBbMode] = useState(_bbMode);
  const bbModeChanged = () => {
    localStorage.setItem("bbMode", !bbMode);
    setBbMode(!bbMode);
  };

  //---------
  //BB MODE
  //---------
  let _sounds =
    localStorage.getItem("sounds") === null ||
    localStorage.getItem("sounds") === "true";
  const [sounds, setSounds] = useState(_sounds);
  const soundsChanged = () => {
    localStorage.setItem("sounds", !sounds);
    setSounds(!sounds);
  };

  //---------
  //RATIO
  //---------
  const ratio = size.width / AspectRatio.refWidth;
  const fontSize = Math.floor(AspectRatio.refFontSize * ratio);
  const disclaimerPadding = Math.floor(AspectRatio.refFontSize * ratio/3);
  const lineHeight = Math.floor(fontSize * 0.8);
  const progressSize = Math.floor(AspectRatio.refFontSize * ratio * 0.75);
  const progressMargin = Math.floor(AspectRatio.refFontSize * ratio) * 0.15;
  const playSize = Math.floor(AspectRatio.refFontSize * ratio) * 2;

  const buttonMargin =
    AspectRatio.refButtonMargin * ratio < AspectRatio.refButtonMargin
      ? Math.floor(AspectRatio.refButtonMargin * ratio)
      : Math.floor(AspectRatio.refButtonMargin);

  const buttonBorderWidth = AspectRatio.refChipsBorderWidth * ratio;

  const doSetCurrentActionIndex = (index) => {
    let _hand = ReplayHand.from(hand);
    //console.log("actions, index[" + index + "]", _hand.actions.length);
    let _action = _hand.getAction(index);

    //sounds
    if (_action && sounds) {
      //console.log("_action", _action);
      document.getElementById("FLOP").playbackRate = 3;
      document.getElementById("TURN").playbackRate = 3;
      document.getElementById("RIVER").playbackRate = 3;
      if (
        _action.eventType === HandEventType.STEP &&
        (_action.step === "FLOP" ||
          _action.step === "TURN" ||
          _action.step === "RIVER")
      ) {
        try {
          document.getElementById(_action.step).play();
        } catch (error) {}
      } else if (
        _action.eventType === HandEventType.CHECK ||
        _action.eventType === HandEventType.CALL ||
        _action.eventType === HandEventType.BET ||
        _action.eventType === HandEventType.RAISE ||
        _action.eventType === HandEventType.COLLECT
      ) {
        try {
          document.getElementById(_action.eventType).play();
        } catch (error) {}
      } else if (_action.eventType === HandEventType.FOLD) {
        try {
          document.getElementById("TURN").play();
        } catch (error) {}
      }
    }
    setCurrentActionIndex(index);
  };

  //--------------
  //NAVIGATION
  //--------------
  const playOrStop = (stop = true) => {
    if (!playing && currentActionIndex === hand.actions.length - 1) {
      doSetCurrentActionIndex(0);
    }
    setPlaying(!playing);
  };
  const stop = () => {
    setPlaying(false);
  };

  const previousHand = () => {
    setPlaying(false);
    if (window.bridge){
      window.bridge.previousHand();
    } else if (sessionHands)
    {
      setHand(sessionHands[handIndex-2]);
      setHandIndex(handIndex-1);
      setCurrentActionIndex(0);
      setError(null);
      setFetching(false);
    }
  };
  const tenLessHand = () => {
    setPlaying(false);
    if (window.bridge){
      window.bridge.tenLessHand();
    } else if (sessionHands)
    {
      setHand(sessionHands[handIndex-11]);
      setHandIndex(handIndex-10);
      setCurrentActionIndex(0);
      setError(null);
      setFetching(false);
    }
  };
  const previousAction = (stop = true) => {
    if (stop) {
      setPlaying(false);
    }
    doSetCurrentActionIndex(currentActionIndex - 1);
  };
  const nextAction = (stop = true) => {
    if (stop) {
      setPlaying(false);
    }
    doSetCurrentActionIndex(currentActionIndex + 1);
  };
  const nextHand = () => {
    setPlaying(false);
    if (window.bridge){
      window.bridge.nextHand(true);
    } else if (sessionHands)
    {
      setHandIndex(handIndex+1);
      setCurrentActionIndex(0);
      setHand(sessionHands[handIndex]);
      setError(null);
      setFetching(false);
    }
  };
  const tenMoreHand = () => {
    setPlaying(false);
    if (window.bridge){
      window.bridge.tenMoreHand();
    } else if (sessionHands)
    {
      setHand(sessionHands[handIndex+9]);
      setHandIndex(handIndex+10);
      setCurrentActionIndex(0);
      setError(null);
      setFetching(false);
    }
  };
  const firstHand = () => {
    setPlaying(false);
    if (window.bridge){
      window.bridge.firstHand();
    } else if (sessionHands)
    {
      setHand(sessionHands[0]);
      setHandIndex(1);
      setCurrentActionIndex(0);
      setError(null);
      setFetching(false);
    }
  };
  const lastHand = () => {
    setPlaying(false);
    if (window.bridge){
      window.bridge.lastHand();
    } else if (sessionHands)
    {
      setHand(sessionHands[sessionHands.length-1]);
      setHandIndex(sessionHands.length);
      setCurrentActionIndex(0);
      setError(null);
      setFetching(false);
    }
  };
  const showAction = (index) => {
    setPlaying(false);
    doSetCurrentActionIndex(index);
  };

  const initAction = (_action) => {
    setAction(_action);
  };

  const { t } = useTranslation();

  const isBrowserFullscreenSupported = () => {
    if (typeof document.fullscreenElement !== "undefined") {
      return "fullscreenElement";
    } else if (typeof document.mozFullScreenElement !== "undefined") {
      return "mozFullScreenElement";
    } else if (typeof document.msFullscreenElement !== "undefined") {
      return "msFullscreenElement";
    } else if (typeof document.webkitFullscreenElement !== "undefined") {
      return "webkitFullscreenElement";
    } else {
      return null;
    }
  };

  const toggleFullscreen = () =>
  {
    //console.log("toggleFullscreen");
    if (mode === ReplayerMode.EMBEDDED || mode === ReplayerMode.CODE) {
      window.open("../w/" + hand.id, "_blank");
    } else {
      setFullScreen((prev) => !prev);
      if (mode === ReplayerMode.SOFTWARE)
      {
        if(window.bridge) window.bridge.toggleFullscreen();
      } else {
        if (!fullScreen) {
          window.parent.enterFullscreen(reportChange);
        } else {
          window.parent.exitFullscreen(reportChange);
        }
      }
    }
  };

  const reportChange = 
    (state, _handle) => {
      //console.log('Screen went to', state, _handle);
      if (mode !== ReplayerMode.SOFTWARE) {
        setFullScreen(!fullScreen);
      }
    }

  //--------------
  //EFFECT
  //--------------
  useEffect(() =>
  {
    
    /*
    const test = { my: 'super', puper: [456, 567], awesome: 'pako' };

    const restored = pako.inflate(compressed, { to: 'string' });
    
    console.log("replayer effect", restored);
    */
    const _replayId = match.params.id;
    
    const scrollListener = (evt) => {
      if (window.parent && window.parent.replayerScrolled) {
        //console.log("scroll", evt);
        window.parent.replayerScrolled(evt);
      }
    };

    if (mode === ReplayerMode.APP || mode === ReplayerMode.APP_STANDALONE) {
      window.addEventListener("wheel", scrollListener);
    }

    const log =
      mode === ReplayerMode.EMBEDDED ||
      mode === ReplayerMode.APP ||
      mode === ReplayerMode.APP_STANDALONE;

    //---------
    //timeline
    //---------
    let _timeline =
      localStorage.getItem("timeline") === null ||
      localStorage.getItem("timeline") === "true";
    localStorage.setItem("timeline", _timeline);
    setShowTimeline(_timeline);

    if (
      mode !== ReplayerMode.SOFTWARE &&
      _replayId !== null &&
      _replayId !== undefined &&
      _replayId.length > 0 &&
      _replayId !== replayId
    ) {
      console.log("fetching", _replayId + "/" + replayId);
      let url =
        window.serverUrl+"/social/hand.php?id=" +
        _replayId +
        "&log=" +
        log;
      console.log("url", url);
      fetch(url)
        .then((r) => r.json())
        .then((_data) => {
          let _hand = ReplayHand.from(_data);
          //console.log("hand", _hand);
          if (_hand.sessionHands)
          {
            setSessionHands(_hand.sessionHands);
            setTotal(_hand.sessionHands.length);
            //console.log("total", _hand.sessionHands.length);
          } else
          {
            setTotal(1);
            setSessionHands(null);
          }
          setReplayId((prevId) => _replayId);
          setAnonymous(_hand.anonymous);
          setHand(_hand);
          if (hand.handNum !== _hand.handNum) {
            setCurrentActionIndex((prevIndex) => 0);
          }

          //console.log("hand.background", hand.background);
          if (
            _hand.background !== "" &&
            assets["background" + _hand.background]
          ) {
            setBackground(_hand.background);
          }
          //console.log("hand.table", hand.table);
          if (_hand.table !== "" && assets["table" + _hand.table]) {
            setTable(_hand.table);
          }

          const assetsValues = [];
          assetsValues.push(assets["background" + _hand.background]);
          assetsValues.push(assets["table" + _hand.table]);

          Preload(assetsValues, [], 0, (_current, _total) => {
            setPreloadCurrent((prevState) => _current);
            setPreloadTotal((prevState) => _total);
            if (_current === _total) {
              try {
                document.getElementById("loader").className += " loaded";
              } catch (error) {}
              setTimeout(() => {
                try {
                  document.getElementById("loader").className = document
                    .getElementById("loader")
                    .className.replace(" loaded", "");
                } catch (err) {}
                setFetching(false);
                setError(null);
                setTimeout(() => {
                  setLoaded(true);
                }, 500);
              }, 500);
            }
          });
        })
        .catch((err) => {
          setError(
            "We apologize for the inconvenience, please try again later"
          );
          setFetching(false);
          console.error("fetch problem", err);
        });
    }

    const doSetCurrentActionIndexEffect = (index) => {
      let _hand = ReplayHand.from(hand);
      //console.log("actions, index[" + index + "]", _hand.actions.length);
      let _action = _hand.getAction(index);

      //sounds
      if (_action && sounds) {
        //console.log("_action", _action);
        document.getElementById("FLOP").playbackRate = 3;
        document.getElementById("TURN").playbackRate = 3;
        document.getElementById("RIVER").playbackRate = 3;
        if (
          _action.eventType === HandEventType.STEP &&
          (_action.step === "FLOP" ||
            _action.step === "TURN" ||
            _action.step === "RIVER")
        ) {
          document.getElementById(_action.step).play();
        } else if (
          _action.eventType === HandEventType.CHECK ||
          _action.eventType === HandEventType.CALL ||
          _action.eventType === HandEventType.BET ||
          _action.eventType === HandEventType.RAISE ||
          _action.eventType === HandEventType.COLLECT
        ) {
          document.getElementById(_action.eventType).play();
        } else if (_action.eventType === HandEventType.FOLD) {
          document.getElementById("TURN").play();
        }
      }
      setCurrentActionIndex(index);
    };

    const onKeyUp = (e) => {
      e.preventDefault();
      // console.log("software", software);
      /*
      console.log("e.key", e.keyCode);
      console.log("handIndex", handIndex);
      console.log("total", total);
      */
      if (e.keyCode === 38) {
        //arrow up
        if (currentActionIndex < nbActions - 1) {
          setPlaying(false);
          doSetCurrentActionIndexEffect(currentActionIndex + 1);
        }
      } else if (e.keyCode === 40) {
        //arrow down
        if (currentActionIndex > 0) {
          setPlaying(false);
          doSetCurrentActionIndexEffect(currentActionIndex - 1);
        }
      } else if (e.keyCode === 37) {
        //arrow left
        if (mode === ReplayerMode.SOFTWARE && handIndex > 1)
        {
          //nextHand();
          //setPlaying(false);
          previousHand();
        }
      } else if (e.keyCode === 39) {
        //arrow right
        if (mode === ReplayerMode.SOFTWARE && handIndex < total) {
          //setPlaying(false);
          nextHand(false);
          //sendCommand("replay/nextHand", {manual : true});
        }
      } else if (e.keyCode === 77) {
        //letter m
        setSounds(!sounds);
      } else if (e.keyCode === 83) {
        //letter s
        if (speed < 2) {
          localStorage.setItem("speed", speed + 1);
          setSpeed(speed + 1);
        } else {
          localStorage.setItem("speed", 1);
          setSpeed(1);
        }
      } else if (e.keyCode === 84) {
        //letter t
        localStorage.setItem("timeline", !showTimeline);
        setShowTimeline(!showTimeline);
      } else if (e.keyCode === 32) {
        //play/stop > space
        setPlaying(!playing);
      }
    };
    window.addEventListener("keydown", onKeyUp, false);

    if (hand != null) {
      if (hand.background !== "" && assets["background" + hand.background]) {
        setBackground(hand.background);
      }
      //console.log("hand.table", hand.table);
      if (hand.table !== "" && assets["table" + hand.table]) {
        setTable(hand.table);
      }
    }

    let _action = hand.getAction(currentActionIndex);
    //console.log("_action", _action);
    if (_action) {
      initAction(_action);
      setNbActions(hand.getActions().length);
      setPreferredSeat(ReplayerPreferredSeats["seats" + hand.nbSeats]);
      _action.players.forEach((player) => {
        if (player.pseudo.toLowerCase() === hand.hero.toLowerCase()) {
          setMainSeat(player.seat);
          //console.info("FOUND MAIN SEAT", mainSeat);
        }
      });
      //console.info("PREFERRED SEAT", preferredSeat);

      //TIMER
      let delay =
        _action.eventType === HandEventType.SHOW ? 100 : 2000 - speed * 500;
      if (mode !== ReplayerMode.SOFTWARE && !loaded) {
        delay += 2000;
      }
      const timer = setTimeout(() => {
        if (playing && currentActionIndex < hand.actions.length - 1) {
          doSetCurrentActionIndexEffect(currentActionIndex + 1);
        } else if (playing && currentActionIndex === hand.actions.length - 1) {
          if (window.bridge)
          {
            window.bridge.nextHand(false);
          } else if (sessionHands && handIndex < total)
          {
            setHandIndex(handIndex+1);
            setCurrentActionIndex(0);
            setHand(sessionHands[handIndex]);
            setError(null);
            setFetching(false);
          } else
          {
            setPlaying(false);
          }
        } else {
          setPlaying(false);
        }
      }, delay);

      return () => {
        window.removeEventListener("keydown", onKeyUp);
        if (mode === ReplayerMode.APP || mode === ReplayerMode.APP_STANDALONE) {
          window.removeEventListener("wheel", scrollListener);
        }

        //console.log("done ok");
        clearTimeout(timer);
      };
    } else {
      window.removeEventListener("keydown", onKeyUp);
      if (mode === ReplayerMode.APP || mode === ReplayerMode.APP_STANDALONE) {
        window.removeEventListener("wheel", scrollListener);
      }
      return () => {
        //console.log("done null");
      };
    }
  }, [
    match.params.id,
    replayId,
    mode,
    loaded,
    hand,
    hand.handNum,
    hand.hero,
    hand.actions.length,
    playing,
    currentActionIndex,
    size,
    speed,
    preferredSeat,
    mainSeat,
    hand.background,
    hand.table,
    showTimeline,
    handIndex,
    nbActions,
    total,
    sounds
  ]);

  //--------------
  //CONTENT
  //--------------
  return (
    <>
      {mode === ReplayerMode.EMBEDDED ? <GATracker></GATracker> : <></>}
      <Div100vh id="main-replayer" className="div-100vh">
        {fetching ? (
          <div
            id="loader"
            className="w-100 h-100 d-flex flex-column align-items-center"
          >
            <img id="logo" src={logo} alt="Xeester Logo"></img>
            <br />
            <ProgressBar now={(preloadCurent * 100) / preloadTotal} />
          </div>
        ) : error !== null ? (
          <div
            id="loader"
            className="w-100 h-100 d-flex flex-column align-items-center"
          >
            <img id="logo" src={logo} alt="Xeester Logo"></img>
            <br />
            <div className="progress">&nbsp;</div>
          </div>
        ) : hand.error !== 401 && hand.error !== 404 ? (
          <>
                            { showDisclaimer && hand.statistics && hand.statistics[hand.hero] ? 
                                  <div className="hud-disclaimer"><div className="hud-disclaimer-text">{t("hudDisclaimer")}&nbsp;&nbsp;<span className="close" onClick={closeDisclaimer}>X</span></div></div>: <></>}
            <table
              id="_replayer"
              cellSpacing="0"
              cellPadding="0"
              className={
                "replayer " +
                background +
                " table" +
                table +
                (loaded ? " loaded" : "")
              }
              style={{
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundImage:
                  background !== null
                    ? `url(${assets["background" + background]})`
                    : `url(${assets.backgroundDark2})`,
                backgroundColor: background === null ? "#444" : ""
              }}
            >
              <tbody>
                <tr>
                  <td style={{ height: "100%" }}>
                    <style
                      dangerouslySetInnerHTML={{
                        __html:
                          `
  .btn{
    padding : ` +
                          buttonMargin +
                          `px !important;
    margin-right : ` +
                          buttonMargin +
                          `px;
    margin-left : ` +
                          buttonMargin +
                          `px;
  }
  .action-progress{
    height : ` +
                          progressSize +
                          `px !important;
    font-size : ` +
                          Math.floor(progressSize * 0.75) +
                          `px !important;
  }
  .actionbar button{
    border-width : ` +
                          buttonBorderWidth +
                          `px;
                      }

  .actions-progress{
    margin-top : ` +
                          progressMargin +
                          `px !important;
    margin-bottom : ` +
                          progressMargin +
                          `px !important;
  }
  .modal-header button{
    font-size : ` +
                          fontSize +
                          `px !important;
  }
  .hud-disclaimer {
    //padding-top : ` + disclaimerPadding + `px !important;
    font-size : ` + fontSize + `px !important;
  }
  .hud-disclaimer-text{
    padding : ` + disclaimerPadding + `px `+ (disclaimerPadding*2) + `px !important;
    border-bottom-right-radius : ` + fontSize + `px !important;;
  }
  .hud-label{
    //padding : `+ (disclaimerPadding*2) + `px !important;
    font-size : ` + fontSize + `px !important;
    line-height : ` + fontSize + `px !important;
  }

  .hud-label .nav-tabs .nav-item {
    padding : 0 ` + disclaimerPadding + `px !important;
  }
  .hud-label .hud-bloc{
      padding :  `+ Math.floor(disclaimerPadding/2) + `px  `+ disclaimerPadding + `px !important;
  }
  .hud-label .hud-box{
      margin : 0 ` + Math.floor(disclaimerPadding/2) + `px;
      font-size : ` + fontSize + `px !important;
  }
  .hud-label .hud-box div{
      margin : 0 ` + Math.floor(disclaimerPadding/2) + `px;
      font-size : ` + fontSize + `px !important;
  }
  .hud-tab{
    padding : `+ (disclaimerPadding*2) + `px !important;
  }
  .hud-label .nav-item{
    padding : `+ Math.floor(disclaimerPadding/2) + `px !important;
  }
`
                      }}
                    ></style>
                    <table className="outer-zone">
                      <tbody>
                        <tr>
                          <td style={{ height: "100%" }}>
                            <div
                              className="header"
                              style={{
                                fontSize: fontSize + "px",
                                display:
                                  mode === ReplayerMode.SOFTWARE ||
                                  mode === ReplayerMode.APP ||
                                  mode === ReplayerMode.APP_STANDALONE
                                    ? "none"
                                    : "inline"
                              }}
                            >
                              &nbsp;{RoomType[hand.roomType]}&nbsp;-&nbsp;
                              {hand.sessionName.trim()}&nbsp;{ hand.fullSession?"(FULL)":""}
                              <br />
                              &nbsp;
                              {new Intl.DateTimeFormat(i18n.language, {
                                year: "numeric",
                                month: "long",
                                day: "2-digit",
                                hour: "2-digit",
                                minute: "2-digit",
                                second: "2-digit"
                              }).format(hand.startDate)}
                              &nbsp;
                            </div>
                            <div
                              className="hand-progress"
                              style={{
                                fontSize: fontSize + "px",
                                display:
                                  total>1
                                    ? "inline"
                                    : "none"
                              }}
                            >
                              &nbsp;{t("hand")}&nbsp;
                              <NumberFormat
                                value={handIndex}
                                displayType={"text"}
                                thousandSeparator={true}
                                decimalScale="2"
                                renderText={(value) => <>{value}</>}
                              />
                              /&nbsp;
                              <NumberFormat
                                value={total}
                                displayType={"text"}
                                thousandSeparator={true}
                                decimalScale="2"
                                renderText={(value) => <>{value}</>}
                              />
                            </div>

                            <audio id="FLOP" controls>
                              <source src={flopMP3} type="audio/mp3" />
                              <source src={flopWAV} type="audio/wav" />
                            </audio>
                            <audio id="TURN" controls>
                              <source src={turnMP3} type="audio/mp3" />
                              <source src={turnWAV} type="audio/wav" />
                            </audio>
                            <audio id="RIVER" controls>
                              <source src={riverMP3} type="audio/mp3" />
                              <source src={riverWAV} type="audio/wav" />
                            </audio>
                            <audio id="CHECK" controls>
                              <source src={checkMP3} type="audio/mp3" />
                              <source src={checkWAV} type="audio/wav" />
                            </audio>
                            <audio id="CALL" controls>
                              <source src={callMP3} type="audio/mp3" />
                              <source src={callWAV} type="audio/wav" />
                            </audio>
                            <audio id="BET" controls>
                              <source src={betMP3} type="audio/mp3" />
                              <source src={betWAV} type="audio/wav" />
                            </audio>
                            <audio id="RAISE" controls>
                              <source src={raiseMP3} type="audio/mp3" />
                              <source src={raiseWAV} type="audio/wav" />
                            </audio>
                            <audio id="COLLECT" controls>
                              <source src={collectMP3} type="audio/mp3" />
                              <source src={collectWAV} type="audio/wav" />
                            </audio>
                            <ReplayZone
                                  hand={hand}
                                  action={action}
                                  mainSeat={mainSeat}
                                  preferredSeat={preferredSeat}
                                  bbMode={bbMode}
                                  fontSize={fontSize}
                                  mode={mode}
                                  fullScreen={fullScreen}
                                  anonymous={anonymous}
                                  showAllCards={showAllCards}
                                  table={table}
                                  showShortcuts={showShortcuts}
                                  onStats={() => stop()}
                                  onBBModeChanged={bbModeChanged}
                            ></ReplayZone>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
                {showTimeline === true ? (
                  <tr>
                    <td>
                      <div className="w-100 actions-progress ">
                        {hand.actions.map((action, index) =>
                          action.eventType === "STEP" ? (
                            <div
                              key={action.step + index}
                              className={
                                index < currentActionIndex
                                  ? "action-flow done " + action.step
                                  : index === currentActionIndex
                                  ? "action-flow done current " +
                                    action.step
                                  : "action-flow " + action.step
                              }
                              style={{ width: 100 / nbActions + "%" }}
                              onClick={() => showAction(index)}
                            >
                              <div
                                className={
                                  action.eventType === "STEP"
                                    ? "action-progress step"
                                    : "action-progress"
                                }
                              >
                                &nbsp;{action.step.substring(0, 1)}&nbsp;
                              </div>
                            </div>
                          ) : (
                            <div
                              key={action.step + index}
                              className={
                                index <= currentActionIndex
                                  ? "action-flow done"
                                  : "action-flow d-flex"
                              }
                              style={{ width: 100 / nbActions + "%" }}
                              onClick={() => showAction(index)}
                            >
                              <div
                                className={
                                  action.eventType === "STEP"
                                    ? "action-progress step"
                                    : "action-progress"
                                }
                              >
                                &nbsp;
                              </div>
                            </div>
                          )
                        )}
                      </div>
                    </td>
                  </tr>
                ) : (
                  <></>
                )}
                <tr>
                  <td className="actionbar">
                     <div
                        id="left-buttons"
                        className="d-flex flex-row"
                        style={{ fontSize: fontSize + "px" }}
                      >
                        <Button
                          onClick={soundsChanged}
                          style={{
                            fontSize: playSize + "px",
                            lineHeight: playSize + "px",
                            backgroundColor: "rgba(0,0,0,0)"
                          }}
                        >
                          {sounds ? (
                            <VolumeUpFill></VolumeUpFill>
                          ) : (
                            <VolumeMuteFill></VolumeMuteFill>
                          )}
                        </Button>
                        <Button
                          onClick={speedChanged}
                          style={{
                            fontSize: fontSize + "px",
                            lineHeight: playSize + "px",
                            backgroundColor: "rgba(0,0,0,0)"
                          }}
                        >
                          x {speed}
                        </Button>
                        <Button
                          onClick={bbModeChanged}
                          style={{
                            fontSize: fontSize + "px",
                            lineHeight: playSize * 1.4 + "px",
                            backgroundColor: "rgba(0,0,0,0)"
                          }}
                        >
                          {bbMode ? "BB" : "Chips"}
                        </Button>
                      </div>
                      <div id="center-buttons">
                          <ButtonGroup>
                          {total > 1 ? (
                            <Button
                              onClick={() => firstHand()}
                              disabled={handIndex === 1}
                              style={{
                                fontSize: fontSize + "px",
                                lineHeight: lineHeight + "px"
                              }}
                            >
                              <SkipBackwardFill></SkipBackwardFill>
                            </Button>
                          ) : (
                            <></>
                          )}
                          {total > 1 ? (
                            <Button
                              onClick={() => tenLessHand()}
                              disabled={handIndex <= 10}
                              style={{
                                fontSize: fontSize * 0.7 + "px",
                                lineHeight: fontSize * 1.15 + "px"
                              }}
                            >
                              -10
                            </Button>
                          ) : (
                            <></>
                          )}
                          {total > 1 ? (
                            <Button
                              onClick={() => previousHand()}
                              disabled={handIndex === 1}
                              style={{
                                fontSize: fontSize + "px",
                                lineHeight: lineHeight + "px"
                              }}
                            >
                              <SkipBackward></SkipBackward>
                            </Button>
                          ) : (
                            <></>
                          )}
                          &nbsp;&nbsp;
                          <Button
                            onClick={() => previousAction(true)}
                            disabled={currentActionIndex === 0}
                            style={{
                              fontSize: fontSize + "px",
                              lineHeight: lineHeight + "px"
                            }}
                          >
                            <SkipStart></SkipStart>
                          </Button>
                          <Button
                            onClick={playOrStop}
                            style={{
                              fontSize: playSize + "px",
                              lineHeight: playSize * 0.8 + "px"
                            }}
                          >
                            {playing ? (
                              currentActionIndex === nbActions - 1 ? (
                                <ArrowRepeat />
                              ) : (
                                <StopFill />
                              )
                            ) : currentActionIndex === nbActions - 1 ? (
                              <ArrowRepeat />
                            ) : (
                              <PlayFill />
                            )}
                          </Button>
                          <Button
                            onClick={() => nextAction(true)}
                            disabled={currentActionIndex === nbActions - 1}
                            style={{
                              fontSize: fontSize + "px",
                              lineHeight: lineHeight + "px"
                            }}
                          >
                            <SkipEnd></SkipEnd>
                          </Button>
                          &nbsp;&nbsp;
                          {total > 1 ? (
                            <Button
                              onClick={() => nextHand()}
                              disabled={handIndex === total}
                              style={{
                                fontSize: fontSize + "px",
                                lineHeight: lineHeight + "px"
                              }}
                            >
                              <SkipForward></SkipForward>
                            </Button>
                          ) : (
                            <></>
                          )}
                          {total > 1 ? (
                            <Button
                              onClick={() => tenMoreHand()}
                              disabled={handIndex >= total - 10}
                              style={{
                                fontSize: fontSize * 0.7 + "px",
                                lineHeight: fontSize * 1.15 + "px"
                              }}
                            >
                              +10
                            </Button>
                          ) : (
                            <></>
                          )}
                          {total > 1 ? (
                            <Button
                              onClick={() => lastHand()}
                              disabled={handIndex === total}
                              style={{
                                fontSize: fontSize + "px",
                                lineHeight: lineHeight + "px"
                              }}
                            >
                              <SkipForwardFill></SkipForwardFill>
                            </Button>
                          ) : (
                            <></>
                          )}
                        </ButtonGroup>
                      </div>
                      <div id="right-buttons" className="d-flex flex-row">
                        <Button
                          id="options"
                          onClick={() => {
                            setPlaying(false);
                            doSetShowOptions(true);
                          }}
                          style={{
                            fontSize: fontSize + "px",
                            lineHeight: playSize + "px",
                            backgroundColor: "rgba(0,0,0,0)",
                            display:
                              mode === ReplayerMode.SOFTWARE ? "inline" : "none"
                          }}
                        >
                          {t("options")}
                        </Button>
                        <Button
                          onClick={() => {
                            setPlaying(false);
                            doSetShowShortcuts(!showShortcuts);
                          }}
                          style={{
                            fontSize: playSize + "px",
                            lineHeight: playSize + "px",
                            backgroundColor: "rgba(0,0,0,0)"
                          }}
                        >
                          <Keyboard></Keyboard>
                        </Button>
                        <Button
                          id="fullscreen-button"
                          onClick={toggleFullscreen}
                          style={{
                            fontSize: fontSize + "px",
                            lineHeight: playSize + "px",
                            backgroundColor: "rgba(0,0,0,0)",
                            display:
                              isBrowserFullscreenSupported() &&
                              mode !== ReplayerMode.SOFTWARE
                                ? "inline"
                                : "none"
                          }}
                        >
                          {fullScreen ? (
                            <FullscreenExit></FullscreenExit>
                          ) : (
                            <Fullscreen></Fullscreen>
                          )}
                        </Button>
                      </div>
                  </td>
                </tr>
              </tbody>
            </table>
            <OptionsDialog
              show={showOptions}
              selectedBackground={background}
              selectedTable={table}
              handleClose={() => {
                doSetShowOptions(false);
              }}
              onBackgroundChange={onBackgroundChange}
              onTableChange={onTableChange}
              ratio={ratio}
            ></OptionsDialog>
          </>
        ) : hand.error === 401 ? (
          <div className="replayer-not-allowed d-flex align-items-center">
            <span className="m-auto">{t("not_allowed")}</span>
          </div>
        ) : (
          <div className="replayer-not-allowed d-flex align-items-center">
            <span className="m-auto">{t("non-existing")}</span>
          </div>
        )}
      </Div100vh>
    </>
  );
}

export default withRouter(Replayer);
